import { VirtualScroller } from 'primereact/virtualscroller'
import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'

export const GlobalSearchList = (props: {
    title: string
    list: any[]
    fullHeight: boolean
    onViewAll: any
    onClick: (item: any) => void
    totalSize: number
}) => {
    const { title, list, fullHeight, onViewAll, onClick, totalSize } = props
    const rowHeight: number = 30
    const [maxItemCompactView, setMaxCompactView] = useState<number>(5)

    useEffect(() => {
        if (list && totalSize) {
            setMaxCompactView(totalSize > 5 ? 5 : totalSize)
        }
    }, [list, totalSize])

    const intl = useIntl()
    const viewAllButton = intl
        .formatMessage({
            id: 'navbar.viewAll',
            defaultMessage: 'View All',
        })
        .toUpperCase()
    const totalResults = intl
        .formatMessage({
            id: 'navbar.search.totalResults',
            defaultMessage: 'Total Results',
        })
        .toUpperCase()

    const basicItemTemplate = (item: any, options: any) => {
        return (
            <div
                key={item.title}
                style={{ height: `${rowHeight}px` }}
                className="global-search-result-list-item"
                onClick={(e: any) => onClick(item)}
                role="button"
                tabIndex={0}>
                {item.title}
            </div>
        )
    }
    return (
        <div
            className="global-search-result-wrapper"
            key={title}
            style={{ marginBottom: 'var(--spacing-7)' }}>
            <h6 className="global-search-result-title">{title}</h6>
            <div
                style={{
                    height: fullHeight
                        ? '100%'
                        : `${maxItemCompactView * rowHeight}px`,
                }}>
                <VirtualScroller
                    className="global-search-result-list"
                    items={
                        fullHeight
                            ? list
                            : list.filter(
                                  (item: any, index: number) =>
                                      index < maxItemCompactView
                              )
                    }
                    itemSize={rowHeight}
                    itemTemplate={basicItemTemplate}
                    scrollHeight={
                        !fullHeight
                            ? `${maxItemCompactView * rowHeight}px`
                            : `${totalSize * rowHeight}px`
                    }
                />
            </div>
            {!fullHeight && totalSize > maxItemCompactView && (
                <div className="global-search-result-toolbox">
                    <span className="total-items">
                        {totalSize} {totalResults}
                    </span>
                    <span
                        onClick={onViewAll}
                        role="button"
                        tabIndex={0}
                        className="view-all">
                        {viewAllButton}
                    </span>
                </div>
            )}
        </div>
    )
}
